import { format } from 'date-fns';

export const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return format(date, 'h:mm a');
};

export const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
        case 'active':
            return 'green';
        case 'pending':
            return 'yellow';
        case 'closed':
            return 'red';
        default:
            return 'default';
    }
};